export default (app) => {
    return {
        pushPurchase(data, user) {
            if (data) {
                const attr = {
                    email: user?.email || '',
                    ecommerce: {
                        transaction_id: data.incrementId,
                        affiliation: '1Byte',
                        value: data.grandTotal,
                        currency: data.currencyId,
                        tax: data.taxAmount,
                        items: data.items.map((i) => {
                            return {
                                item_id: i.key,
                                item_name: i.name,
                                price: i.price,
                                quantity: i.qty ?? 1,
                            };
                        }),
                    },
                };
                app.$gtm.push({ ecommerce: null }); // Clear the previous ecommerce object.
                app.$gtm.push({ event: 'purchase', ...attr });

                // SEO Facebook
                const fbTrackAttr = {
                    content_ids: data.items.map((pro) => pro.productKey),
                    content_type: 'product',
                    contents: data.items.map((pro) => {
                        return {
                            id: pro.productKey,
                            quantity: pro.qty ?? 1,
                            name: pro.name, // Optional
                            price: pro.price, // Optional
                        };
                    }),
                    currency: data.currencyId,
                    value: data.grandTotal,
                    transaction_id: data.incrementId, // Optional
                    affiliation: '1Byte', // Optional
                    tax: data.taxAmount, // Optional
                }; // https://developers.facebook.com/docs/meta-pixel/reference#object-properties
                app.$metaConversionsApi.track('Purchase', fbTrackAttr);
            }
        },
    };
};
